//* 组件属性
import type { ModuleData } from "../../index";

export const ModuleEmits = {
    change: (_data: ModuleData[], _callback: () => void, _key?: number) => true,
};
